import { render } from "./section.vue?vue&type=template&id=3c0b1d60&scoped=true"
import script from "./section.vue?vue&type=script&lang=js"
export * from "./section.vue?vue&type=script&lang=js"

import "./section.vue?vue&type=style&index=0&id=3c0b1d60&lang=scss&scoped=true"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0b1d60"]])

export default __exports__